<template>
  <div class="exports">
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="订单类型" v-if="type=='order'">
        <Select v-model="searchCondition.order_type" style="width:200px;" clearable>
          <Option v-for="item in orderType" :value="item.key" :key="item.key">{{item.value}}</Option>
          <Option value="7" key="7">拼团订单</Option>
        </Select>
      </FormItem>
      <FormItem label="任务状态">
        <Select v-model="searchCondition.status" style="width:200px;" clearable>
          <Option v-for="item in taskStatus" :value="item.key" :key="item.key">{{item.value}}</Option>
        </Select>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/export/task"
        :search="searchCondition"
        :rowsFormatter="onRowsForamtter"
        @onSelectionChange="onSelectionChange"
        selectType
        keyField="id"
        method="get"
      >
        <template slot-scope="{row}" slot="action">
          <div>
            <Button type="text" size="small" @click="onDownload(row)" v-if="row.status==2">下载</Button>
            <span v-if="row.status==2">-</span>
            <Button
              type="text"
              size="small"
              @click="onDelete(row)"
              v-if="row.status==0||row.status==2"
            >删除</Button>
          </div>
        </template>
      </Grid>
    </div>
  </div>
</template>

<script>
import { ExportTaskType, ExportTaskStatus, OrderType } from "@/utils/enums";
import Grid from "@/components/Grid";

export default {
  name: "exports",
  components: {
    Grid
  },
  data() {
    return {
      searchCondition: {
        type: "",
        order_type: "",
        status: "",
        init: function() {
          (this.order_type = ""), (this.status = "");
        }
      },
      taskType: ExportTaskType.getOptions(),
      taskStatus: ExportTaskStatus.getOptions(),
      orderType: OrderType.getOptions(),
      tableColumns: [
        { title: "任务名称", key: "name" },
        { title: "申请时间", key: "created_at", align: "center", width: 170 },
        { title: "申请人", key: "creator", align: "center", width: 140 },
        { title: "任务类型", key: "typeName", align: "center", width: 140 },
        { title: "状态", key: "statusName", align: "center", width: 100 },
        { title: "操作", slot: "action", align: "center", width: 100 }
      ],
      selectRows: [],
      type: this.$route.query.type,
      order_type: this.$route.query.order_type
    };
  },
  created() {
    switch (this.type) {
      case "student":
        this.searchCondition.type = "1";
        break;
      case "teacher":
        this.searchCondition.type = "2";
        break;
      case "order":
        this.searchCondition.type = "3";
        break;
      case "vip":
        this.searchCondition.type = "4";
        break;
      case "assist":
        this.searchCondition.type = "5";
        break;
      case "integral":
        this.searchCondition.type = "9";
        break;
    }
    if( this.order_type ) {
      this.searchCondition.order_type = this.order_type
    }
  },
  methods: {
    onRowsForamtter(rows) {
      rows.forEach(i => {
        i.statusName = ExportTaskStatus.getValue(i.status);
        i.created_at = this.$pub.timestampToTime(i.created_at);
        i.typeName = ExportTaskType.getValue(i.type);
      });
    },
    onSelectionChange(items) {
      this.selectRows = items;
    },
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.init();
      this.$refs.grid.searchRefresh();
    },
    onDownload(row) {
      window.open(row.download_url);
    },
    onDelete(row) {
      let ids = row.id;
      let content = "";
      if (row.status == 0) {
        content = "删除后该任务将被取消，确定删除吗？";
      } else {
        content = "确定删除该记录吗？";
      }
      this.$Modal.confirm({
        title: "提示",
        content,
        onOk: () => {
          this.$http.delete("/api/export/task/" + ids).then(() => {
            this.$Message.success("删除成功");
            this.$refs.grid.refresh();
          });
        }
      });
    }
  }
};
</script>
